import { T } from '@tribeplatform/react-components/i18n'

import { MediaSettings } from '../MediaSettings.js'

export function CommunityMediaSettingsRouter() {
  return <MediaSettings />
}

export function CommunityMediaSettingsBreadCrumb() {
  return <T id="Settings.Media" defaultMessage="Media" />
}
